module.exports = __webpack_public_path__ + "img/geriatrics.fcf7f789.svg";